import { render, staticRenderFns } from "./depositRecords.vue?vue&type=template&id=1673a2f2&"
import script from "./depositRecords.vue?vue&type=script&lang=js&"
export * from "./depositRecords.vue?vue&type=script&lang=js&"
import style0 from "./depositRecords.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports